import React, { memo } from "react";

import SvgIcon from "@mui/material/SvgIcon";

export const CloseIcon = memo((props) => {
  return (
    <SvgIcon viewBox="0 0 21 20" {...props}>
      <mask
        id="mask0"
        mask-type="alpha"
        maskUnits="userSpaceOnUse"
        x="0"
        y="0"
        width="21"
        height="20"
      >
        <rect x="0.996094" width="20" height="20" fill="#C4C4C4" />
      </mask>
      <g mask="url(#mask0)">
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M13.6477 9.99956L19.393 4.25431L16.7413 1.60266L10.9961 7.34791L5.25085 1.60266L2.5992 4.25431L8.34444 9.99956L2.5992 15.7448L5.25085 18.3965L10.9961 12.6512L16.7413 18.3965L19.393 15.7448L13.6477 9.99956Z"
          fill="white"
        />
      </g>
    </SvgIcon>
  );
});
